// extracted by mini-css-extract-plugin
export default {"invoice_detail__container":"invoiceDetail_invoice_detail__container__CbJU5","invoice_detail_description":"invoiceDetail_invoice_detail_description__j1swx"};